import { getJson, sendJson } from './api';

/**
 * An event's no-login payment link, as staff manage it (needs manage_payments):
 * read, make, email and revoke. The link opens the client portal's payment
 * page, where anyone holding it can pay the event's balance.
 */

export interface PaymentLink {
  readonly id: string;
  readonly url: string;
  readonly createdAt: string;
  readonly openCount: number;
  readonly lastOpenedAt: string | null;
  readonly lastSentAt: string | null;
  readonly lastSentTo: readonly string[];
}

export interface PaymentLinkView {
  readonly link: PaymentLink | null;
  /** The event's primary contact, to pre-fill the send form. */
  readonly suggestedRecipient: { readonly name: string | null; readonly email: string } | null;
}

export interface SendPaymentLinkInput {
  readonly to: readonly string[];
  readonly recipientName?: string;
  readonly message?: string;
}

export const paymentLinkQueryKey = (eventId: string) => ['payment-link', eventId] as const;

export function readPaymentLink(eventId: string, signal?: AbortSignal): Promise<PaymentLinkView> {
  return getJson<PaymentLinkView>(`/events/${eventId}/payment-link`, undefined, signal);
}

export function createPaymentLink(eventId: string): Promise<PaymentLink> {
  return sendJson('post', `/events/${eventId}/payment-link`, {});
}

export function sendPaymentLink(eventId: string, input: SendPaymentLinkInput): Promise<PaymentLink> {
  return sendJson('post', `/events/${eventId}/payment-link/send`, input);
}

export function revokePaymentLink(linkId: string): Promise<{ revoked: boolean }> {
  return sendJson('delete', `/payment-links/${linkId}`);
}

/** Addresses typed into one box: split on commas, semicolons and spaces. */
export function parseRecipients(value: string): string[] {
  return [...new Set(value.split(/[\s,;]+/).map((part) => part.trim().toLowerCase()).filter(Boolean))];
}
